import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'

import { EMERGENCY_HELP_PATH, LEGACY_EMERGENCY_HELP_PATH } from './paths'

/**
 * `/emergency-help/...` → its `/emergency/...` twin (M36-T11). Replace, not
 * push, so Back does not bounce through the old address. The rest of the path
 * and the query string (`?hospital=` on screen 4) are kept.
 */
export function LegacyEmergencyHelp(): ReactNode {
  const { pathname, search, hash } = useLocation()
  const rest = pathname.slice(LEGACY_EMERGENCY_HELP_PATH.length)
  return (
    <Navigate to={`${EMERGENCY_HELP_PATH}${rest}${search}${hash}`} replace />
  )
}
